import React from 'react';
import { BO_GLYPH } from './boGlyph.generated';

/**
 * Bo's one-colour glyph: the kettlebell's handle and bell, the plate knocked
 * out as a real hole, so it takes `currentColor` on any ground. The paths
 * come from the app's geometry (boGlyph.generated.js, written by
 * scripts/generate-brand-assets.mjs) - never redraw them here.
 */
const BoGlyph = ({ size = 28, title, className = '' }) => (
  <svg
    viewBox={BO_GLYPH.viewBox}
    height={size}
    width={Math.round(size * BO_GLYPH.aspect)}
    className={className}
    role={title ? 'img' : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : 'true'}
    style={{ display: 'block', flex: 'none' }}
  >
    <path
      d={BO_GLYPH.handle}
      fill="none"
      stroke="currentColor"
      strokeWidth={BO_GLYPH.handleWidth}
      strokeLinecap="round"
    />
    <path d={BO_GLYPH.body} fill="currentColor" fillRule="evenodd" />
  </svg>
);

export default BoGlyph;
